import { ScansSection } from '../../../../components/patient/monitoring/ScansSection';

interface ReviewMonitoringPaneProps {
    patientId: string | null;
    dmId: number;
    totalAligners: number | null;
}

export function ReviewMonitoringPane({
    patientId,
    dmId,
    totalAligners
}: ReviewMonitoringPaneProps) {
    return (
        <div className="h-full bg-white rounded-xl border border-gray-200 flex flex-col overflow-hidden font-inter">
            <div className="flex-1 min-h-0 p-5 flex flex-col overflow-hidden">
                <ScansSection patientId={patientId} dmId={dmId} totalAligners={totalAligners} />
            </div>
        </div>
    );
}
